// onboarding.store.js
//
// Frontend wrapper for GET /v1/onboarding/status — owner-only endpoint that
// returns onboarding progress + live counts (agents invited, vendors
// invited/active, homeowners active) and a health block once onboarding is
// complete. The Authorization header is set globally on axios in main.js
// (see `axios.defaults.headers.common['Authorization']`), so we just call
// the URL here. Non-owners get a 403 from the backend, which we swallow
// quietly — the admin panel renders nothing in that case.
import axios from "axios";
import config from "@/config/constants.js";

export default {
  namespaced: true,
  state: {
    status: null,
  },
  mutations: {
    SET_STATUS(state, payload) {
      state.status = payload;
    },
  },
  actions: {
    async fetchStatus({ commit }) {
      try {
        const response = await axios.get(
          config.api_url + "onboarding/status"
        );
        if (response && response.data && response.data.code === "SUCCESS") {
          commit("SET_STATUS", response.data.data);
          return response.data.data;
        }
        commit("SET_STATUS", null);
        return null;
      } catch (error) {
        // 403 → user is not the tenant owner; fall back silently.
        // Any other error is logged but doesn't surface to the user — this
        // card is supplementary, not load-bearing.
        const status = error && error.response && error.response.status;
        if (status !== 403) {
          console.error("[Onboarding/fetchStatus] error:", error);
        }
        commit("SET_STATUS", null);
        return null;
      }
    },
    clear({ commit }) {
      commit("SET_STATUS", null);
    },
  },
};
